import { adminConstants } from '../constants';

const initialState = {
    loading: false,
    admins: [],
    error: null,
    creatingAdmin: false,
    createError: null,
    updatingAdmin: false,
    updateError: null,
};

const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case adminConstants.FETCH_ADMINS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case adminConstants.FETCH_ADMINS_SUCCESS:
            return {
                ...state,
                loading: false,
                admins: action.admins,
                error: null
            };
        case adminConstants.FETCH_ADMINS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case adminConstants.CREATE_ADMIN_REQUEST:
            return {
                ...state,
                creatingAdmin: true,
                createError: null,
            };
        case adminConstants.CREATE_ADMIN_SUCCESS:
            return {
                ...state,
                creatingAdmin: false,
                createError: null,
            };
        case adminConstants.CREATE_ADMIN_FAILURE:
            return {
                ...state,
                creatingAdmin: false,
                createError: action.payload,
            };

        case adminConstants.UPDATE_ADMIN_REQUEST:
            return {
                ...state,
                updatingAdmin: true,
                updateError: null,
            };
        case adminConstants.UPDATE_ADMIN_SUCCESS:
            return {
                ...state,
                admins: action.admins,
                // admins: state.admins.map(admin =>
                //     admin.UserID === action.admin.UserID ? action.admin : admin
                // ),
                updatingAdmin: false,
                updateError: null,
            };
        case adminConstants.UPDATE_ADMIN_FAILURE:
            return {
                ...state,
                updatingAdmin: false,
                updateError: action.payload,
            };
        case adminConstants.DISABLE_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case adminConstants.DISABLE_ADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                admins: state.admins.map((admin) =>
                    admin.UserID === action.payload
                        ? { ...admin, EnabledFlag: 'N' }
                        : admin
                ),
            };
        case adminConstants.DISABLE_ADMIN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default adminReducer;
